import { getAuthorizationCode } from "@/api/user";
import { getSystemData } from "@/api/workbench";

interface Request {
  cardId: string;
  appKey: string;
  interfaceUrl: string;
  resolve: Function;
  reject: Function;
  [key: string]: any;
}

interface IRequestObj {
  [key: string]: Request;
}

interface AccessToken {
  appKey: string;
  token: string;
}

interface IAccessTokenObj {
  [key: string]: AccessToken;
}

class CardRequestService {
  requests: IRequestObj;
  accessTokenList: IAccessTokenObj;
  constructor() {
    this.requests = {};
    this.accessTokenList = {};
  }
  addRequest(value: Request) {
    this.requests[value.layoutId] = value;
  }
  removeRequest(id: string) {
    delete this.requests[id];
  }
  addAccessToken(value: AccessToken) {
    this.accessTokenList[value.appKey] = value;
  }
  clearAccessToken() {
    this.accessTokenList = {};
  }
  clearRequest() {
    this.requests = {};
  }
  getCardData(cardId: string) {
    const request = this.requests[cardId];
    if (!request) {
      return;
    }
    const appkey = request.relatedApplication?.applicationKey;
    const accessToken = this.accessTokenList[appkey]; // eslint-disable-line
    const url = JSON.parse(request.dataSource).url;
    if (request.openable === 0) {
      getSystemData(url.pc, request.extendParams).then((res) => {
        request.resolve(res);
        this.removeRequest(cardId);
      });
    } else {
      // if (accessToken) {
      let fetchUrl = url.pc;
      this.getCode(appkey).then(([res, err]) => {
        if (res) {
          const linkTag = fetchUrl?.indexOf("?") > -1 ? "&" : "?";
          let newFetchUrl = `${fetchUrl}${linkTag}code=${res.code}`;
          fetch(
            fetchUrl
              ? newFetchUrl
              : "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/gwork/test/workbenche-mock.json?times=1",
            {
              method: "GET",
              mode: "cors",
              credentials: "include"
            }
          )
            .then((res) => {
              const Authentication = res.headers.get("Authentication");
              const Authorization = res.headers.get("Authorization");
              const Token = res.headers.get("Token");
              let searchStr = `authorization=${Authorization}&authentication=${Authentication}&token=${Token}`;
              return res.json().then((resObj) => {
                if (Authentication && Authorization && Token) {
                  resObj.auth = searchStr;
                }
                return resObj;
              });
            })
            .then((res) => {
              request.resolve(res);
              this.removeRequest(cardId);
            })
            .catch((e) => {
              console.log(e);
            });
        }
      });
      // } else {
      //   this.getCode(appkey).then((res: any) => {
      //     request.resolve(res);
      //     this.accessTokenList[appkey] = res?.header?.accessToken;
      //     this.removeRequest(cardId);
      //   });
      // }
    }
  }
  baseRequest(request: Request & { url: string }) {
    // const request = this.requests[data.cardId];
    if (!request) {
      return;
    }
    if (request.openable === 0) {
      return getSystemData(request.url, request.extendParams);
    } else {
      // if (accessToken) {
      fetch("https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/gwork/test/workbenche-mock.json", {
        method: "GET",
        mode: "cors",
        credentials: "include"
      });
    }
  }
  getCode(appKey: string) {
    return getAuthorizationCode({ appKey });
  }
}

export default new CardRequestService();
